import React from 'react';

const InfoNewIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.99984 5.66699V6.50033M8.99984 8.58366V12.3337M8.99984 17.3337C13.6022 17.3337 17.3332 13.6027 17.3332 9.00033C17.3332 4.39795 13.6022 0.666992 8.99984 0.666992C4.39746 0.666992 0.666504 4.39795 0.666504 9.00033C0.666504 13.6027 4.39746 17.3337 8.99984 17.3337Z" stroke="#5941A9" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default InfoNewIcon;
